// All UTC offsets a user might select for birth time.
// Format: { value: "-05:00", label: "GMT-05:00 (Eastern Standard, NYC)" }
export const TIMEZONES = [
    { value: "-12:00", label: "GMT-12:00 (Baker Island)" },
    { value: "-11:00", label: "GMT-11:00 (American Samoa)" },
    { value: "-10:00", label: "GMT-10:00 (Hawaii)" },
    { value: "-09:00", label: "GMT-09:00 (Alaska Standard)" },
    { value: "-08:00", label: "GMT-08:00 (Pacific Standard, LA)" },
    { value: "-07:00", label: "GMT-07:00 (Mountain Standard, Denver)" },
    { value: "-06:00", label: "GMT-06:00 (Central Standard, Chicago)" },
    { value: "-05:00", label: "GMT-05:00 (Eastern Standard, NYC)" },
    { value: "-04:00", label: "GMT-04:00 (Atlantic, Eastern Daylight)" },
    { value: "-03:30", label: "GMT-03:30 (Newfoundland)" },
    { value: "-03:00", label: "GMT-03:00 (Argentina, Brazil East)" },
    { value: "-02:00", label: "GMT-02:00 (Mid-Atlantic)" },
    { value: "-01:00", label: "GMT-01:00 (Azores)" },
    { value: "+00:00", label: "GMT+00:00 (UTC, London Winter)" },
    { value: "+01:00", label: "GMT+01:00 (Central European, Paris)" },
    { value: "+02:00", label: "GMT+02:00 (Eastern European, Cairo)" },
    { value: "+03:00", label: "GMT+03:00 (Moscow, East Africa)" },
    { value: "+03:30", label: "GMT+03:30 (Iran)" },
    { value: "+04:00", label: "GMT+04:00 (Gulf, Dubai)" },
    { value: "+04:30", label: "GMT+04:30 (Afghanistan)" },
    { value: "+05:00", label: "GMT+05:00 (Pakistan)" },
    { value: "+05:30", label: "GMT+05:30 (India, Sri Lanka)" },
    { value: "+05:45", label: "GMT+05:45 (Nepal)" },
    { value: "+06:00", label: "GMT+06:00 (Bangladesh)" },
    { value: "+06:30", label: "GMT+06:30 (Myanmar)" },
    { value: "+07:00", label: "GMT+07:00 (Indochina, Bangkok)" },
    { value: "+08:00", label: "GMT+08:00 (China, Singapore, Perth)" },
    { value: "+09:00", label: "GMT+09:00 (Japan, Korea)" },
    { value: "+09:30", label: "GMT+09:30 (Central Australia)" },
    { value: "+10:00", label: "GMT+10:00 (Eastern Australia)" },
    { value: "+11:00", label: "GMT+11:00 (Solomon Islands)" },
    { value: "+12:00", label: "GMT+12:00 (New Zealand)" },
    { value: "+13:00", label: "GMT+13:00 (Samoa)" },
    { value: "+14:00", label: "GMT+14:00 (Kiribati)" },
];

// Guess the closest GMT offset for given lat/lng using current browser locale.
// Fallback to "+00:00" if unknown.
export function guessTimezoneOffset() {
    try {
        const offsetMin = -new Date().getTimezoneOffset();
        const sign = offsetMin >= 0 ? "+" : "-";
        const abs = Math.abs(offsetMin);
        const h = String(Math.floor(abs / 60)).padStart(2, "0");
        const m = String(abs % 60).padStart(2, "0");
        return `${sign}${h}:${m}`;
    } catch {
        return "+00:00";
    }
}
